import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';
import { updateUserBalance } from '../user/updateUserBalance';
import { updateMasterBalance } from '../master/updateMasterBalance';

export const createTransaction = ({
   masterId,
   command,
   amount,
   credit
}) => async dispatch => {
   dispatch({
      type: actionTypes.CREATE_TRANSACTION_START
   })
   const options = {
      url: `/transactions/masters/${masterId}`,
      method: 'POST',
      data: {
         command,
         amount,
         credit
      }
   }
   await axios(options)
      .then(response => {
         dispatch({
            type: actionTypes.CREATE_TRANSACTION_SUCCESS,
            payload: response.data
         });
         dispatch(updateMasterBalance(response.data));
         dispatch(updateUserBalance(response.data));
      })
      .catch(error => dispatch({
         type: actionTypes.CREATE_TRANSACTION_FAIL,
         payload: getMessage(error)
      }))
}